import type { RunSummary } from './types.js'

/**
 * The machine a run's commands go to. A just-started run can stream its first question before
 * the cached run list has it, so an unknown machine is resolved from a fresh list instead of
 * signing (and encrypting) a command addressed to no machine.
 */
export async function runMachine(
  known: string | undefined,
  runId: string,
  listRuns: () => Promise<Pick<RunSummary, 'runId' | 'machineId'>[]>,
): Promise<string> {
  if (known) return known
  const found = (await listRuns()).find((r) => r.runId === runId)?.machineId
  if (!found) throw new Error('This run has no machine yet.')
  return found
}
